import { useState } from "react";
import { scheduleAlways, scheduleDays } from "@/mocks/festival";

const tagStyles: Record<string, string> = {
  상설: "bg-secondary-100 text-secondary-900",
  품평회: "bg-accent-100 text-accent-900",
  시식회: "bg-accent-100 text-accent-900",
  체험: "bg-accent-100 text-accent-900",
  무대: "bg-primary-100 text-primary-800",
  가요제: "bg-primary-100 text-primary-800",
  특집: "bg-primary-500 text-white",
};

export default function Schedule() {
  const [dayId, setDayId] = useState(scheduleDays[0].id);
  const activeDay = scheduleDays.find((day) => day.id === dayId) ?? scheduleDays[0];

  return (
    <section id="schedule" className="w-full bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <div className="reveal flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <span className="text-xs tracking-[0.24em] text-primary-600">TIME TABLE</span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950">
              이틀간의 축제 일정
            </h2>
            <p className="mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              품평회와 시식회, 수확체험부터 개막 축하공연과 거봉가요제까지.
              시간대별 프로그램을 확인하고 나만의 축제 코스를 계획해 보세요.
            </p>
          </div>

          <div className="flex rounded-full bg-background-200/70 p-1">
            {scheduleDays.map((day) => (
              <button
                key={day.id}
                type="button"
                onClick={() => setDayId(day.id)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-5 py-2.5 text-sm transition-colors duration-300 ${
                  day.id === dayId
                    ? "btn-gradient text-white"
                    : "text-foreground-700 hover:text-primary-700"
                }`}
              >
                <strong className="font-medium">{day.label}</strong>
                <span className="ml-2 text-xs opacity-80">{day.date}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6 lg:gap-10">
          <aside className="reveal">
            <div className="rounded-lg bg-gradient-animate p-6 md:p-7 text-white lg:sticky lg:top-24">
              <span className="text-xs tracking-[0.2em] text-white/75">{activeDay.label}</span>
              <strong className="mt-2 block font-heading text-2xl">{activeDay.date}</strong>
              <p className="mt-3 text-sm leading-relaxed text-white/85">{activeDay.theme}</p>
              <div className="mt-6 border-t border-white/20 pt-5">
                <span className="text-xs tracking-[0.18em] text-white/70">상설 프로그램</span>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {scheduleAlways.map((item) => (
                    <span key={item} className="rounded-full bg-white/15 px-2.5 py-1 text-[11px]">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </aside>

          <div className="reveal reveal-delay-2">
            <ul className="flex flex-col">
              {activeDay.events.map((event, i) => (
                <li key={`${activeDay.id}-${event.time}-${i}`} className="flex gap-4 md:gap-6">
                  <div className="flex flex-col items-center pt-5">
                    <span className="font-heading text-sm md:text-base text-primary-700 tabular-nums whitespace-nowrap">
                      {event.time}
                    </span>
                    <span className="mt-3 w-px flex-1 bg-background-300"></span>
                  </div>
                  <div className="flex-1 rounded-lg border border-background-200 bg-background-50 px-4 py-4 md:px-6 md:py-5 mb-3">
                    <div className="flex flex-wrap items-center gap-2">
                      <span
                        className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
                          tagStyles[event.tag] ?? "bg-background-200 text-foreground-700"
                        }`}
                      >
                        {event.tag}
                      </span>
                      <strong className="font-heading text-base md:text-lg text-foreground-950">
                        {event.title}
                      </strong>
                    </div>
                    <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">{event.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-2 text-xs text-foreground-500">
              * 세부 시간과 출연 순서는 현장 운영 상황에 따라 변경될 수 있습니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}